import { Box, Typography } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';
import { RunnerPageHeading } from '../components/RunnerPageHeading';
import { Panel } from '../components/Panel';
import { RunnerAction } from '../components/RunnerAction';
import { runnerTheme } from '../styles/runnerTheme';

const publicSite = (import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined) ?? 'https://www.grocerylistplus.com';

export default function Help() {
  const { t } = useTranslation();
  const sections = [
    { title: 'runnerNav.faq', description: 'runnerHelp.faqDescription', href: `${publicSite}/faq?topic=drive` },
    { title: 'runnerNav.contact', description: 'runnerHelp.contactDescription', href: `${publicSite}/contact?topic=drive` },
    { title: 'header.kit', description: 'runnerHelp.kitDescription', href: '/kit' },
    { title: 'header.handbook', description: 'runnerHelp.handbookDescription', href: '/handbook' },
  ];
  return <Box data-testid="page-help" sx={{ display: 'grid', gap: '12px' }}>
    <RunnerPageHeading title={t('runnerNav.help')} subtitle={t('runnerHelp.subtitle')} topic="support" />
    {sections.map(section => <Panel key={section.title} accent={runnerTheme.navy}>
      <Typography component="h2" sx={{ fontSize: 14, fontWeight: 600, mb: 1.5, color: runnerTheme.ink }}>
        <Box component="a" href={section.href} sx={{ color: 'inherit', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>{t(section.title)}</Box>
      </Typography>
      <Typography sx={{ fontSize: 14, color: runnerTheme.muted }}>{t(section.description)}</Typography>
    </Panel>)}
    <RunnerAction appearance="primary" ariaLabel={t('runnerHelp.browseFaq')} buttonText={t('runnerHelp.browseFaq')} href={`${publicSite}/faq?topic=drive`} />
    <RunnerAction topic="support" ariaLabel={t('runnerHelp.contactSupport')} buttonText={t('runnerHelp.contactSupport')} href={`${publicSite}/contact?topic=drive`} />
    <RunnerAction ariaLabel={t('runnerHelp.returnToRuns')} buttonText={t('runnerHelp.returnToRuns')} href="/runs" />
  </Box>;
}
